import { FileUrlDomainException } from '~/modules/TrophyMemories/Domain/FileUrlDomainException'
import { FileUrl } from '~/modules/TrophyMemories/Domain/FileUrl'

export class AbsoluteFileUrl extends FileUrl {
  private readonly _url: string
  private readonly _filename: string
  private readonly _extension: string
  private readonly _domain: string

  constructor (url: string) {
    super()

    this._url = url
    let jsUrl

    try {
      jsUrl = new URL(url)
    } catch (exception: unknown) {
      throw FileUrlDomainException.invalidFileUrl(url)
    }

    this._domain = jsUrl.host
    const lastUrlFragment = jsUrl.pathname.split('/').pop()

    if (!lastUrlFragment) {
      throw FileUrlDomainException.cannotExtractFilename(url)
    }

    const extension = lastUrlFragment.split('.')[1]

    if (!extension) {
      throw FileUrlDomainException.cannotExtractExtension(url)
    }

    this._filename = decodeURI(lastUrlFragment)
    this._extension = extension
    this._domain = jsUrl.hostname
  }

  get url (): string {
    return this._url
  }

  get domain (): string {
    return this._domain
  }

  getExtension (): string {
    return this._extension
  }

  getFilename (): string {
    return this._filename
  }

  // TODO: Find a better way to implement this method
  public static canParse (url: string): boolean {
    try {
      // eslint-disable-next-line no-new
      new AbsoluteFileUrl(url)

      return true
    } catch (exception: unknown) {
      return false
    }
  }

  public toString (): string {
    return this._url
  }
}
